import { jsx, jsxs } from "@ecopages/jsx/jsx-runtime";
import { withDefaultAriaLabel } from "@/aria";
import { cx } from "@/lib/cx";
import "./number-field.script";
export function RuiNumberFieldGroup({
  children,
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsx("div", {
    ...props,
    "data-number-field-group": true,
    class: cx("rui-number-field__group", className),
    children
  });
}
export function RuiNumberFieldInput({
  class: className,
  disabled,
  readOnly,
  ...props
}) {
  return /* @__PURE__ */jsx("input", {
    ...props,
    type: "text",
    "data-number-field-input": true,
    "data-rui-control": true,
    "data-rui-control-type": "number",
    class: cx("rui-number-field__input", className),
    disabled,
    readOnly
  });
}
export function RuiNumberFieldSteppers({
  children,
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsx("div", {
    ...props,
    class: cx("rui-number-field__steppers", className),
    children
  });
}
export function RuiNumberFieldIncrementButton({
  children,
  class: className,
  aria,
  disabled,
  ...props
}) {
  return /* @__PURE__ */jsx("button", {
    ...props,
    aria: withDefaultAriaLabel(aria, "Increment"),
    type: "button",
    "data-number-field-action": "increment",
    class: cx("rui-number-field__stepper", className),
    disabled,
    tabIndex: -1,
    children: children ?? "+"
  });
}
export function RuiNumberFieldDecrementButton({
  children,
  class: className,
  aria,
  disabled,
  ...props
}) {
  return /* @__PURE__ */jsx("button", {
    ...props,
    aria: withDefaultAriaLabel(aria, "Decrement"),
    type: "button",
    "data-number-field-action": "decrement",
    class: cx("rui-number-field__stepper", className),
    disabled,
    tabIndex: -1,
    children: children ?? "\u2212"
  });
}
function NumberFieldDefaultGroup() {
  return /* @__PURE__ */jsxs(RuiNumberFieldGroup, {
    children: [/* @__PURE__ */jsx(RuiNumberFieldInput, {}), /* @__PURE__ */jsx("input", {
      type: "hidden",
      "data-number-field-value": true
    }), /* @__PURE__ */jsxs(RuiNumberFieldSteppers, {
      children: [/* @__PURE__ */jsx(RuiNumberFieldDecrementButton, {}), /* @__PURE__ */jsx(RuiNumberFieldIncrementButton, {})]
    })]
  });
}
export function RuiNumberField({
  children,
  ...props
}) {
  return /* @__PURE__ */jsx("rui-number-field", {
    ...props,
    children: /* @__PURE__ */jsx("div", {
      class: "rui-number-field",
      "data-ref": "root",
      children: children ?? /* @__PURE__ */jsx(NumberFieldDefaultGroup, {})
    })
  });
}